import { useCallback, useEffect, useMemo, useState } from "react";
import { IOptions } from "components/DropdownSelect";
import { AxiosRequest } from "_services/api";

export function useRenomearArquivos() {
  const [optionsRenomear, setOptionsRenomear] = useState<IOptions[]>([]);
  const api = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    [],
  );

  const buscarPadroesRenomearArquivos = useCallback(async () => {
    try {
      const { data } = await api.get("/arquivos/padroes");
      montarOptionsRenomearArquivos(data);
    } catch (e) {
      setOptionsRenomear([
        { label: "{placa}-{ano}-CRLV", value: "{placa}-{ano}-CRLV" },
      ]);
    }
  }, [api]);

  useEffect(() => {
    buscarPadroesRenomearArquivos();
  }, [buscarPadroesRenomearArquivos]);

  function montarOptionsRenomearArquivos(dados: any[]) {
    const options: IOptions[] = dados.map((item) => ({
      label: item.padrao,
      value: item.padrao,
    }));
    options.unshift({
      label: "{placa}-{ano}-CRLV",
      value: "{placa}-{ano}-CRLV",
    });
    setOptionsRenomear(options);
  }

  return {
    optionsRenomear,
  };
}
